import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./Login.css";
import "react-toastify/dist/ReactToastify.css";
import { useFormWithValidation } from "../../Hook/useFormWithValidation";
import { FiEye, FiEyeOff } from "react-icons/fi";
//import GoogleSignInButton from "../Auth/GoogleSignInButton";

// те же ссылки, что и на регистрации
const LEGAL_LINKS = {
  PRIVACY_URL: "/docs/privacy",
  TERMS_URL: "/docs/terms",
  OFFER_URL: "/docs/offer",
};

function ManualResetDialog({ onClose, defaultEmail = "" }) {
  const [email, setEmail] = useState(defaultEmail);
  const [note, setNote] = useState("");
  const [showFallback, setShowFallback] = useState(false);
  const [copied, setCopied] = useState(false);

  const canSubmit = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const sendByMailto = () => {
    // Пробуем открыть локальный почтовый клиент:
    const to = "ktm-online@mail.ru";
    const subject = encodeURIComponent("Заявка на восстановление пароля");
    const body = encodeURIComponent(
      `Здравствуйте! Прошу помочь восстановить пароль.\n\n` +
      `E-mail аккаунта: ${email}\n` +
      (note ? `Комментарий: ${note}\n` : "") +
      `\n---\nЗаявка отправлена со страницы входа.`
    );
    // Mailto не даёт надёжного события об успехе/ошибке — сразу показываем fallback
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
    setShowFallback(true);
  };

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText("ktm-online@mail.ru");
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // на старых браузерах/HTTP окружении может упасть
      alert("Скопировать не удалось, пожалуйста выделите адрес вручную: ktm-online@mail.ru");
    }
  };

  const openGmail = () => {
    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      "ktm-online@mail.ru"
    )}&su=${encodeURIComponent("Заявка на восстановление пароля")}&body=${encodeURIComponent(
      `Здравствуйте! Прошу помочь восстановить пароль.\n\nE-mail аккаунта: ${email}\n${note ? `Комментарий: ${note}\n` : ""}`
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openYandex = () => {
    const url = `https://mail.yandex.ru/compose?mailto=${encodeURIComponent(
      "ktm-online@mail.ru"
    )}&subject=${encodeURIComponent("Заявка на восстановление пароля")}&body=${encodeURIComponent(
      `Здравствуйте! Прошу помочь восстановить пароль.\n\nE-mail аккаунта: ${email}\n${note ? `Комментарий: ${note}\n` : ""}`
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openMailRu = () => {
    const url = `https://e.mail.ru/compose/?to=${encodeURIComponent(
      "ktm-online@mail.ru"
    )}&subject=${encodeURIComponent("Заявка на восстановление пароля")}&body=${encodeURIComponent(
      `Здравствуйте! Прошу помочь восстановить пароль.\n\nE-mail аккаунта: ${email}\n${note ? `Комментарий: ${note}\n` : ""}`
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="reset-modal">
      <div className="reset-modal__backdrop" onClick={onClose} />
      <div className="reset-modal__panel" role="dialog" aria-modal="true" aria-labelledby="reset-title">
        <h3 className="reset-modal__title" id="reset-title">Восстановление пароля</h3>
        <p className="reset-modal__text">
          Укажите e-mail, на который зарегистрирован аккаунт. Мы свяжемся с вами и поможем восстановить доступ.
        </p>

        <label className="reset-modal__label">
          E-mail
          <input
            className="reset-modal__input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
            placeholder="you@example.com"
            autoFocus
            required
          />
        </label>

        <label className="reset-modal__label">
          Комментарий (необязательно)
          <textarea
            className="reset-modal__textarea"
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Когда последний раз заходили, есть ли доступ к почте и т.п."
          />
        </label>

        <div className="reset-modal__actions">
          <button
            className="reset-modal__btn reset-modal__btn_primary"
            onClick={sendByMailto}
            disabled={!canSubmit}
          >
            Отправить заявку
          </button>
          <button className="reset-modal__btn" onClick={onClose}>Закрыть</button>
        </div>

        <p className="reset-modal__hint">
          Нажимая «Отправить заявку», вы соглашаетесь на обработку данных для восстановления доступа. Подробнее:{" "}
          <a href={LEGAL_LINKS.PRIVACY_URL} target="_blank" rel="noopener noreferrer">Политика</a>.
        </p>

        {/* Fallback-блок (покажем сразу после клика по mailto или всегда, если хотите) */}
        {showFallback && (
          <div className="reset-fallback">
            <p className="reset-fallback__title">Если письмо не открылось автоматически:</p>
            <div className="reset-fallback__row">
              <button className="reset-modal__btn" onClick={copyEmail}>
                {copied ? "Скопировано ✓" : "Скопировать адрес: ktm-online@mail.ru"}
              </button>
            </div>
            <div className="reset-fallback__apps">
              <span className="reset-fallback__apps-label">Или откройте в веб-почте:</span>
              <div className="reset-fallback__apps-buttons">
                <button className="reset-modal__btn" onClick={openGmail}>Gmail</button>
                <button className="reset-modal__btn" onClick={openYandex}>Яндекс.Почта</button>
                <button className="reset-modal__btn" onClick={openMailRu}>Mail.ru</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Login({ handelLogin, handleGoogleLogin, handleGoogleError }) {
  const { values, handleChange, errors, isValid } = useFormWithValidation();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showReset, setShowReset] = useState(false);

  const togglePasswordVisibility = () => setPasswordVisible((v) => !v);

  const handleSubmit = (e) => {
    e.preventDefault();
    handelLogin({
      email: values.email?.trim(),
      password: values.password,
    });
  };

  return (
    <>
      <Helmet>
        <title>Школа КТМ Вход</title>
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://kt-mebel.ru/sign-in" />
      </Helmet>
      <form className="form" onSubmit={handleSubmit} noValidate>
        <Link className="header-container__logo logo_form" to="/" />
        <h1 className="form__name">Войти</h1>

        {/* E-mail */}
        <label className="form__input-name">
          E-mail
          <input
            className={`form__input ${errors.email && "form__input_error"}`}
            type="email"
            id="email"
            name="email"
            required
            onChange={handleChange}
            placeholder="Введите ваш e-mail"
            inputMode="email"
            autoComplete="email"
          />
          <span className="form__imput-error">{errors.email}</span>
        </label>

        {/* Пароль */}
        <label className="form__input-name">
          Пароль
          <div className="password-container">
            <input
              className="form__input form__input_password"
              id="password"
              name="password"
              required
              type={passwordVisible ? "text" : "password"}
              onChange={handleChange}
              placeholder="Введите пароль"
              minLength={8}
              autoComplete="current-password"
            />
            <button
              type="button"
              className="password-toggle-btn"
              aria-label={passwordVisible ? "Скрыть пароль" : "Показать пароль"}
              aria-pressed={passwordVisible}
              onClick={togglePasswordVisibility}
              title={passwordVisible ? "Скрыть пароль" : "Показать пароль"}
            >
              {passwordVisible ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
          <span className="form__imput-error">{errors.password}</span>
        </label>

        <div className="form__row form__row_between">
          <div />
          <button
            type="button"
            className="form__link form__link_button"
            onClick={() => setShowReset(true)}
          >
            Забыли пароль?
          </button>
        </div>

        <button className="form__button" type="submit" disabled={!isValid}>
          Войти
        </button>

       {/* <GoogleSignInButton onCredential={handleGoogleLogin} onError={handleGoogleError} /> */} 

        <div className="form__signin">
          <p className="form__signin-question">Нет аккаунта?</p>
          <Link to="/sign-up" className="form__login-link">Зарегистрироваться</Link>
        </div>

        {/* Юридический блок */}
        <div className="form__legal">
          <p className="form__legal-note">
            Входя в аккаунт, вы подтверждаете, что ознакомлены с{" "}
            <Link to={LEGAL_LINKS.PRIVACY_URL} target="_blank" rel="noopener noreferrer">
              Политикой обработки персональных данных
            </Link>{" "}
            и{" "}
            <Link to={LEGAL_LINKS.TERMS_URL} target="_blank" rel="noopener noreferrer">
              Пользовательским соглашением
            </Link>
            {", "}
            а также условиями{" "}
            <Link to={LEGAL_LINKS.OFFER_URL} target="_blank" rel="noopener noreferrer">
              Договора оферты
            </Link>.
          </p>

          <p className="form__legal-note">
            Оператор персональных данных: Тарасов Евгений Александрович, самозанятый (НПД), ИНН 382801892154, г. Красноярск.{" "}
            Контакт: <a href="mailto:ktm-online@mail.ru">ktm-online@mail.ru</a>
          </p>
        </div>
      </form>

      {showReset && (
        <ManualResetDialog
          onClose={() => setShowReset(false)}
          defaultEmail={(values.email || "").trim()}
        />
      )}
    </>
  );
}

export default Login;
